import React, { Component, Suspense } from "react";
import { createBrowserHistory as createHistory } from "history";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import MainLayout from "../layouts/MainLayout";
import AuthLayout from "../layouts/AuthLayout";
import AuthTempLayout from "../layouts/AuthTempLayout";
import CMSLayout from "../layouts/CMSLayout"
import EditProfile from "../Accounts/Profile/EditProfile";
import ProfileIndex from "../Accounts/Profile/ProfileIndex";
import NotFoundIndex from "../NotFound/NotFoundIndex";
import { Helmet } from "react-helmet";
import configuration from "react-global-configuration";
import { apiConstants } from "../Constant/constants";
import LandingPage from "../LandingPages/LandingPage";
import HowItWorksPage from "../LandingPages/HowItWorksPage";
import AboutPage from "../LandingPages/AboutPage";
import CreatorsNetworkPage from "../LandingPages/CreatorsNetworkPage";
import SubscriberFaqPage from "../LandingPages/SubscriberFaqPage";
import CreatorFaqPage from "../LandingPages/CreatorFaqPage";
import PrivacyPolicyPage from "../LandingPages/PrivacyPolicyPage";
import TermsOfUsePage from "../LandingPages/TermsOfUsePage";
import ContractPage from "../LandingPages/ContractPage";
import LandingPageOld from "../LandingPage/LandingPage";
import Signin from "../LandingPage/Signin";
import Signup from "../LandingPage/Signup";
import Forgot from "../LandingPage/Forgot";
import UserLandingPage from "../UserLandingPage/UserLandingPage";
import HomePageIndex from "../Home/HomePageIndex";
import MessageIndex from "../Messages/MessageIndex";
import BookmarksIndex from "../Bookmarks/BookmarksIndex";
import BookmarkPhoto from "../Bookmarks/BookmarkPhoto";
import BookmarkVideo from "../Bookmarks/BookmarkVideo";
import ModelViewProfile from "../Model/ModelViewProfile";
import FollowingIndex from "../Accounts/FansFollowing/Following/FollowingIndex";
import BlockedIndex from "../Accounts/Blocked/BlockedIndex";
import ListIndex from "../Accounts/List/ListIndex";
import NotificationIndex from "../Notification/NotificationIndex";
import CreatePostIndex from "../Post/CreatePost/CreatePostIndex";
import FavoritesIndex from "../Accounts/Favorites/FavoritesIndex";
import BankingIndex from "../Accounts/Payments/BankingIndex";
import AddBankIndex from "../Accounts/Payments/AddBankIndex";
import Logout from "../Accounts/Logout";
import Wallet from "../Wallet/Wallet";
import BillingAccountIndex from "../Accounts/Payments/BillingAccountIndex";
import DocumentUploadIndex from "../DocumentUpload/DocumentUploadIndex";
import QRCodeIndex from "../QRCode/QRCodeIndex";
import StaticPage from "../StaticPage/StaticPage";
import FanIndex from "../Accounts/FansFollowing/Fans/FanIndex";
import PostView from "../Post/PostView";
import GuestPostView from "../Post/GuestPostView";
import ResetPassword from "../LandingPage/ResetPassword";
import UploadProfilePicture from "../Accounts/Profile/UploadProfilePicture";
import api from "../../Environment";
import EventDetails from "../Event/EventDetails";
import EventPageIndex from "../Event/EventPageIndex";
import CheckoutPage from "../Event/CheckoutPage";
import ConfirmationPage from "../Event/ConfirmationPage";
import ErrorState from "../Error/ErrorState";
import LiveStreamDemo from "../LiveStreamDemo/LiveStreamDemo";

import {
  setTranslations,
  setDefaultLanguage,
  translate,
  setLanguage,
} from "react-multi-lang";
import en from "../translations/en.json";
import es from "../translations/es.json";
import SpinnerLoader from "../Loader/SpinnerLoader";
import MyBookings from "../Event/MyBookings";
import CreatorDashboard from "../Post/CreatorDashboard";
import EditPost from "../Post/EditPost/EditPost";

//lazy load modules
const LiveStream = React.lazy(() => import("../LiveStream/LiveStream"));
const LiveStreamCreate = React.lazy(() => import("../LiveStream/Create/LiveStreamCreate"));
const StreamListIndex = React.lazy(() => import("../LiveStream/StreamListIndex"));
const VideoCall = React.lazy(() => import("../VideoCall/VideoCall"));
const VideoListIndex = React.lazy(() => import("../VideoCall/VideoListIndex"));
const PaymentsIndex = React.lazy(() => import("../Accounts/Payments/PaymentsIndex"));
const CardsIndex = React.lazy(() => import("../Accounts/Payments/CardsIndex"));

setTranslations({ en, es });

const history = createHistory();
const $ = window.$;

const BlankLayout = ({ children }) => <>{children}</>;

const AppRoute = ({
  component: Component,
  layout: Layout,
  screenProps: ScreenProps,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) => (
      <Layout screenProps={ScreenProps} {...props}>
        <Component {...props} />
      </Layout>
    )}
    isAuthed
  />
);

const PrivateRoute = ({
  component: Component,
  layout: Layout,
  screenProps: ScreenProps,
  authentication,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      authentication === true ? (
        <Layout screenProps={ScreenProps}>
          <Component {...props} authRoute={true} />
        </Layout>
      ) : (
        <Redirect to={{ pathname: "/", state: { from: props.location } }} />
      )
    }
  />
);

class App extends Component {
  constructor(props) {
    super(props);
    let userId = localStorage.getItem("userId");
    let accessToken = localStorage.getItem("accessToken");
    this.state = {
      loading: true,
      configLoading: true,
      authentication: userId && accessToken ? true : false,
    };

    history.listen((location, action) => {
      userId = localStorage.getItem("userId");
      accessToken = localStorage.getItem("accessToken");

      this.setState({
        loading: true,
        authentication: userId && accessToken ? true : false,
      });

      document.body.scrollTop = 0;
    });
  }

  componentDidMount() {
    this.fetchConfig();
    let userLanguage = "en";

    localStorage.setItem("lang", userLanguage);
    setLanguage(userLanguage);
  }

  async fetchConfig() {
    try {
      const response = await fetch(apiConstants.settingsUrl);
      const configValue = await response.json();
      configuration.set({ configData: configValue.data }, { freeze: false });
      this.setState({ configLoading: false });
    } catch (error) {
      configuration.set({ configData: [] }, { freeze: false });
      this.setState({ configLoading: false });
    }

    // $("#google_analytics").html(
    //   configuration.get("configData.google_analytics")
    // );
    // $("#header_scripts").html(configuration.get("configData.header_scripts"));
    // $("#body_scripts").html(configuration.get("configData.body_scripts"));
  }

  render() {
    const isLoading = this.state.configLoading;
    const isGuestRoute =
      window.location.pathname.startsWith("/video/");

    if (isLoading) {
      return (
        // Place content loader here
        <div> <SpinnerLoader></SpinnerLoader> </div>
      );
    }

    if (configuration?.get("configData")?.length == 0) {
      return (
        <ErrorState
          message="Something went wrong. Please try again later."
          onRetry={this.fetchConfig()}
        />);
    }

    // const isSnap =
    //   typeof navigator !== "undefined" &&
    //   navigator.userAgent.includes("ReactSnap");

    // if (isSnap) {
    //   const path = window.location.pathname;

    //   let video = {};

    //   if (path.startsWith("/video/")) {
    //     const id = path.split("/")[2];

    //     const videoMeta = {
    //       "PF-486-69b6e38b28647": {
    //         title: "Rebel - PT1-Fresh Magazine",
    //         description: "PT1-Fresh Magazine, created by 3 teens from Queens College in the 80s, bursts on the scene and births a movement for a new generation spanning 30 years, making a permanent imprint on Bahamian youth, pop and entertainment culture, beginning with Island Grooves.",
    //         image: "https://admin.rebeltv.me/storage/uploads/posts/25/7783216f9c59f47262892329f57a1d93801d47c2.jpg",
    //         type: "article",
    //         url: "https://rebeltv.me/video/PF-486-69b6e38b28647"
    //       },
    //       "PF-487-69b6e5a0cab2a": {
    //         title: "Rebel - Thomas Augustus Robinson",
    //         description: "Experience the inspiring story of Bahamian Track & Field legend Thomas Augustus Robinson, exclusively on REBELTV.",
    //         image: "https://admin.rebeltv.me/storage/uploads/posts/25/2d8bacfdabe5f8861b73c8296fca3d37904ee794.jpg",
    //         type: "article",
    //         url: "https://rebeltv.me/video/PF-487-69b6e5a0cab2a"
    //       },
    //       "PF-505-6a3b690118286": {
    //         title: "Rebel - Shaunae Miller's Iconic Gold-Medal Dive",
    //         description: "One of the most iconic finishes in Olympic history... but what really happened? As Shaunae Miller stormed down the final stretch in the Women's 400m Final at the Rio 2016 Olympic Games, victory was within reach. But in the final few meters, everything changed. Did she stumble... Or did she intentionally dive across the finish line to secure Olympic gold for The Bahamas? Nearly a decade later, the debate still continues. Watch the race again in slow motion and decide for yourself.",
    //         image: "https://admin.rebeltv.me/storage/uploads/posts/13/c07e32c9a0e5f67d91ff5a176757160f6e0bb643.png",
    //         type: "article",
    //         url: "https://rebeltv.me/video/PF-505-6a3b690118286"
    //       },
    //       "PF-506-6a3bf8825ce78": {
    //         title: "Rebel - Shaunae Miller's Iconic Gold-Medal Dive",
    //         description: "One of the most iconic finishes in Olympic history... but what really happened? Did she stumble... Or did she intentionally dive across the finish line",
    //         image: "https://admin.rebeltv.me/storage/uploads/posts/25/91792117eb315172121ba145ab0b2d18f2ef0e4a.png",
    //         type: "article",
    //         url: "https://rebeltv.me/video/PF-506-6a3bf8825ce78"
    //       },
    //       "PF-509-6a3e0677913f6": {
    //         title: "Rebel - The Pauline Davis-Thompson Story",
    //         description: "The Journey of a True Champion, Pauline Davis-Thompson, Arguably the Most Decorated Track & Field Bahamian Athlete Ever.",
    //         image: "https://admin.rebeltv.me/storage/uploads/posts/284/1bce8daefa28675b4f4de58783dee326c8fddc6b.png",
    //         type: "article",
    //         url: "https://rebeltv.me/video/PF-509-6a3e0677913f6"
    //       }
    //     };

    //     if (videoMeta[id]) {
    //       video = videoMeta[id];
    //     }
    //   } else {
    //     video = {
    //       title: configuration.get("configData.site_name"),
    //       description: "Get Paid Not Likes",
    //       image: "https://admin.rebeltv.me/" + configuration.get("configData.site_icon"),
    //       type: "website",
    //       url: window.location.href
    //     };
    //   }

    //   return (
    //     <>
    //       <Helmet>
    //         <title>{video.title}</title>

    //         <meta name="description" content={video.description} />

    //         {/* Open Graph */}
    //         <meta property="og:title" content={video.title} />
    //         <meta property="og:description" content={video.description} />
    //         <meta property="og:image" content={video.image} />
    //         <meta property="og:image:secure_url" content={video.image} />
    //         <meta property="og:image:type" content="image/jpeg" />
    //         <meta property="og:image:width" content="1200" />
    //         <meta property="og:image:height" content="630" />

    //         <meta property="og:url" content={window.location.href} />
    //         <meta property="og:type" content="article" />

    //         {/* Twitter/X */}
    //         <meta name="twitter:card" content="summary_large_image" />
    //         <meta name="twitter:title" content={video.title} />
    //         <meta name="twitter:description" content={video.description} />
    //         <meta name="twitter:image" content={video.image} />
    //       </Helmet>
    //     </>
    //   );
    // }

    return (
      <>
        <Switch>

          <AppRoute
            path={"/"}
            component={LandingPage}
            exact
            layout={BlankLayout}
          />

          <AppRoute
            path={"/howitworks"}
            component={HowItWorksPage}
            exact
            layout={BlankLayout}
          />

          <AppRoute
            path={"/about"}
            component={AboutPage}
            exact
            layout={BlankLayout}
          />

          <AppRoute
            path={"/creators"}
            component={CreatorsNetworkPage}
            exact
            layout={BlankLayout}
          />

          <AppRoute
            path={"/subscriber"}
            component={SubscriberFaqPage}
            exact
            layout={BlankLayout}
          />

          <AppRoute
            path={"/creator"}
            component={CreatorFaqPage}
            exact
            layout={BlankLayout}
          />

          <AppRoute
            path={"/privacy"}
            component={PrivacyPolicyPage}
            exact
            layout={BlankLayout}
          />

          <AppRoute
            path={"/terms"}
            component={TermsOfUsePage}
            exact
            layout={BlankLayout}
          />

          <AppRoute
            path={"/contract"}
            component={ContractPage}
            exact
            layout={BlankLayout}
          />

          <AppRoute
            path={"/signin"}
            component={Signin}
            exact
            layout={AuthTempLayout}
          />

          <AppRoute
            path={"/signup"}
            component={Signup}
            exact
            layout={AuthTempLayout}
          />

          <AppRoute
            path={"/forgot"}
            component={Forgot}
            exact
            layout={AuthTempLayout}
          />

          <AppRoute
            path={"/video/:post_unique_id"}
            component={GuestPostView}
            layout={MainLayout}
          />


          <PrivateRoute
            authentication={this.state.authentication}
            path={"/home"}
            exact
            component={HomePageIndex}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/inbox"}
            exact
            component={MessageIndex}
            layout={MainLayout}
          />

          <PrivateRoute
            exact
            authentication={this.state.authentication}
            path={"/posts-create"}
            component={CreatePostIndex}
            layout={MainLayout}
          />

          <PrivateRoute
            exact
            authentication={this.state.authentication}
            path={"/edit-post/:post_unique_id"}
            component={EditPost}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/post/:post_unique_id"}
            component={PostView}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/bookmarks"}
            exact
            component={BookmarksIndex}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/bookmark-photo"}
            component={BookmarkPhoto}
            layout={MainLayout}
          />
          <PrivateRoute
            authentication={this.state.authentication}
            path={"/bookmark-video"}
            exact
            component={BookmarkVideo}
            layout={MainLayout}
          />
          <PrivateRoute
            authentication={this.state.authentication}
            exact
            path={"/following"}
            component={FollowingIndex}
            layout={MainLayout}
          />
          <PrivateRoute
            authentication={this.state.authentication}
            exact
            path={"/blocked"}
            component={BlockedIndex}
            layout={MainLayout}
          />
          <PrivateRoute
            authentication={this.state.authentication}
            exact
            path={"/subscribers"}
            component={FanIndex}
            layout={MainLayout}
          />
          <PrivateRoute
            authentication={this.state.authentication}
            exact
            path={"/favorites"}
            component={FavoritesIndex}
            layout={MainLayout}
          />

          <PrivateRoute
            exact
            authentication={this.state.authentication}
            path={"/list"}
            component={ListIndex}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            exact
            path={"/edit-profile"}
            component={EditProfile}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/profile"}
            exact
            component={ProfileIndex}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/notification"}
            exact
            component={NotificationIndex}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/billing-accounts"}
            exact
            component={BillingAccountIndex}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/add-bank"}
            exact
            component={AddBankIndex}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/banking"}
            exact
            component={BankingIndex}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/wallet"}
            exact
            component={Wallet}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/document-upload"}
            exact
            component={DocumentUploadIndex}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/qrcode"}
            exact
            component={QRCodeIndex}
            layout={MainLayout}
          />

          <AppRoute
            path={"/page/:title"}
            component={StaticPage}
            layout={CMSLayout}
          />

          <AppRoute
            path={"/reset-password/:token"}
            component={ResetPassword}
            layout={AuthLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/upload-profile-picture"}
            exact
            component={UploadProfilePicture}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/logout"}
            exact
            component={Logout}
            layout={MainLayout}
          />

          <AppRoute
            path={"/user/landing-page/:username"}
            component={UserLandingPage}
            layout={AuthLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/payments"}
            exact
            component={(props) =>
              <Suspense fallback={<SpinnerLoader />}><PaymentsIndex  {...props} /></Suspense>}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/streamList"}
            exact
            component={(props) =>
              <Suspense fallback={<SpinnerLoader />}><StreamListIndex  {...props} /></Suspense>}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/callRequest"}
            exact
            component={(props) =>
              <Suspense fallback={<SpinnerLoader />}><VideoListIndex  {...props} /></Suspense>}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/liveStream/:stream_id"}
            exact
            component={(props) =>
              <Suspense fallback={<SpinnerLoader />}><LiveStreamDemo  {...props} /></Suspense>}
            layout={AuthTempLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/liveStreamCreate"}
            exact
            component={(props) =>
              <Suspense fallback={<SpinnerLoader />}><LiveStreamCreate  {...props} /></Suspense>}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/call/:user_id"}
            component={(props) =>
              <Suspense fallback={<SpinnerLoader />}><VideoCall  {...props} /></Suspense>}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            exact
            path={"/cards"}
            component={(props) =>
              <Suspense fallback={<SpinnerLoader />}><CardsIndex  {...props} /></Suspense>}
            layout={MainLayout}
          />

          <AppRoute
            path={"/events"}
            component={EventPageIndex}
            layout={this.state.authentication ? MainLayout : BlankLayout}
          />

          <AppRoute
            path={"/event/:id"}
            component={EventDetails}
            layout={this.state.authentication ? MainLayout : BlankLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/checkout/:eventId"}
            component={CheckoutPage}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/payment-success"}
            component={ConfirmationPage}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/my-bookings"}
            component={MyBookings}
            layout={MainLayout}
          />

          <PrivateRoute
            authentication={this.state.authentication}
            path={"/creator-dashboard"}
            component={CreatorDashboard}
            layout={MainLayout}
          />

          {/* Don't move this route to top */}
          <PrivateRoute
            authentication={this.state.authentication}
            path={"/:username"}
            component={ModelViewProfile}
            layout={MainLayout}
          />

          <Route path="*" component={NotFoundIndex} />

        </Switch>
      </>
    );
  }
}

export default App;
